import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-328cff32"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "unused-title"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "检测到未使用层级", -1));
const _hoisted_3 = {
  class: "unused-body"
};
const _hoisted_4 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "unused-desc"
}, "检测到以下层级当前未分配给任何国家/地区：", -1));
const _hoisted_5 = {
  class: "unused-tags"
};
const _hoisted_6 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "unused-tip"
}, [/*#__PURE__*/_createTextVNode(" 为了保持系统配置整洁，系统将在保存时 "), /*#__PURE__*/_createElementVNode("span", {
  class: "unused-tip-strong"
}, "自动移除"), /*#__PURE__*/_createTextVNode(" 这些空置层级。是否继续？ ")], -1));
import { ExclamationCircleFilled } from '@ant-design/icons-vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'UnusedTierConfirmModal',
  props: {
    open: {
      type: Boolean,
      default: false
    },
    unusedTiers: {
      type: Array,
      default: () => []
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  emits: ['confirm', 'cancel'],
  setup(__props, {
    emit
  }) {
    const onCancel = () => emit('cancel');
    const onConfirm = () => emit('confirm');
    return (_ctx, _cache) => {
      const _component_a_tag = _resolveComponent("a-tag");
      const _component_a_button = _resolveComponent("a-button");
      const _component_a_modal = _resolveComponent("a-modal");
      return _openBlock(), _createBlock(_component_a_modal, {
        open: __props.open,
        width: 480,
        closable: true,
        "wrap-class-name": "unused-tier-modal",
        onCancel: onCancel
      }, {
        title: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createVNode(_unref(ExclamationCircleFilled), {
          class: "unused-title-icon"
        }), _hoisted_2])]),
        footer: _withCtx(() => [_createVNode(_component_a_button, {
          onClick: onCancel
        }, {
          default: _withCtx(() => [_createTextVNode("取消并去分配")]),
          _: 1
        }), _createVNode(_component_a_button, {
          type: "primary",
          loading: __props.loading,
          onClick: onConfirm
        }, {
          default: _withCtx(() => [_createTextVNode("确认并保存")]),
          _: 1
        }, 8, ["loading"])]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_hoisted_4, _createElementVNode("div", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.unusedTiers, lv => {
          return _openBlock(), _createBlock(_component_a_tag, {
            key: lv
          }, {
            default: _withCtx(() => [_createTextVNode(_toDisplayString(lv), 1)]),
            _: 2
          }, 1024);
        }), 128))]), _hoisted_6])]),
        _: 1
      }, 8, ["open"]);
    };
  }
});